import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const AbvMcdPymtActualsSplitList = ({ mcdPymtActualsSplitGrpId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.expr = ExprUtils.and(
        rowsReq.expr,
        ExprUtils.whereParams('mcdPymtActualsSplitGrpId', mcdPymtActualsSplitGrpId),
      );
    },
    [mcdPymtActualsSplitGrpId],
  );

  return <EntityList entity="MCD_PYMT_ACTUALS_SPLIT" augRowsReq={augRowsReq} />;
};
